import { jwtDecode } from 'jwt-decode';

type JWT = {
  exp: number;
  iat: number;
  auth_time: number;
  jti: string;
  iss: string;
  sub: string;
  typ: string;
  azp: string;
  session_state: string;
  acr: string;
  scope: string;
  sid: string;
  email_verified: boolean;
  name: string;
  preferred_username: string;
  given_name: string;
  family_name: string;
  email: string;
};

/**
 * Decode JWT body
 * If token was not specified or is invalid, it returns null
 */
function decode(token = '') {
  if (!token) return null;

  try {
    return jwtDecode<JWT>(token);
  } catch {
    return null;
  }
}

export { decode, type JWT };
